module.exports = __webpack_public_path__ + "img/qna.935a4e7d.svg";